import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
    body {
        background: #dfe2e7;
        font-size: 14px;
        font-family: 'Montserrat', sans-serif;
        color: #495058;
    }
    ul {
        padding-left: 20px;
    }
    a {
        transition: all 0.4s ease;
    }
    a:hover {
        text-decoration: none ;
    }
    h1,
    h2,
    h3,
    h4 {
        margin: 0;
        line-height: 1.2;
        color: #2b97be;
        font-weight: 700;
    }
    h1 {
        font-size: 16px;
    }
    h2 {
        font-size: 14px;
        color: #125578;
    }
    h2 strong {
        color: #2b97be;
    }
    h3 {
        font-size: 14px;
    }
    h4 {
        font-size: 14px;
    }
    figure img {
        max-width: 100%;
        height: auto;
    }
    a {
        color: inherit;
        text-decoration: none;
    }
    .container {
        max-width: 1366px !important;
        width: 100%;
        display: flex;
        flex-flow: wrap;
    }
    .text-right {
        text-align: right;
    }
    .text-center {
        text-align: center;
    }
    .mr-2 {
        margin-right: 1rem;
    }
    .pr-0 {
        padding-right: 0 !important;
    }
    .pl-0 {
        padding-left: 0 !important;
    }
    .pl-1 {
        padding-left: .5rem;
    }
    .col-md-col5 {
        width: 20%;
    }
    .logo img {
        border: none !important;
        outline: none !important;
        box-shadow: none !important;
        display: block; /* evita espaçamento estranho */
    }
    .logo {
        border: none !important;
        outline: none !important;
    }
    .logo:focus,
    .logo:active,
    .logo:hover {
        outline: none;
        border: none;
        box-shadow: none;
    }
    header {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 2;
    }
    header .ttl {
        width: 230px;
        background: #2b97be;
        text-align: center;
        padding: 5px 10px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    header .ttl h1,
    header .ttl h2 {
        color: #ffffff;
    }
    header .rt {
        width: calc(100% - 230px);
        height: 50px;
        background: #ffffff;
    }
    header .rt .col-12 {
        height: 50px;
        display: flex;
        align-items: center;
    }
    header .rt ul.users {
        list-style: none;
        margin: 0 40px 0 0;
        padding: 0;
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
    header .rt ul.users li {
        margin: 0 0 0 10px;
    }
    header .rt ul.users li a {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        width: 30px;
    }
    header .rt ul.users li a img {
        height: 28px;
        width: 28px;
        border-radius: 100px;
        object-fit: cover;
        margin: 0;
    }
    header .rt ul.users li a span {
        margin: 2px 0 0 0;
        font-size: 9px;
        line-height: 1.2;
        height: 10px;
        overflow: hidden;
    }
    header .rt a.user {
        display: flex;
        align-items: center;
        font-weight: 500;
        text-decoration: none;
        color: #495058;
    }
    header .rt a.user i {
        font-size: 24px;
        margin: 0 5px 0 0;
    }
    #wrapcontent {
        overflow: hidden;
        min-height: 100vh;
        width: 100%;
        display: flex;
    }
    #wrapcontent aside.sidebar {
        width: 230px;
        display: flex;
        flex-flow: column;
        background: #ffffff;
    }
    #wrapcontent aside.sidebar nav {
        height: calc(100vh - 50px);
        overflow-y: auto;
        margin-top: 50px;
        position: fixed;
    /* Track */
    /* Handle */
    /* Handle on hover */
    }
    #wrapcontent aside.sidebar nav::-webkit-scrollbar {
        width: 5px;
    }
    #wrapcontent aside.sidebar nav::-webkit-scrollbar-track {
        background: #f2f2f2;
        border-radius: 20px;
    }
    #wrapcontent aside.sidebar nav::-webkit-scrollbar-thumb {
        background: #c8e6f0;
        border-radius: 20px;
    }
    #wrapcontent aside.sidebar nav::-webkit-scrollbar-thumb:hover {
        background: #125578;
    }
    #wrapcontent aside.sidebar nav ul {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-flow: column;
    }
    #wrapcontent aside.sidebar nav ul li {
        width: 100%;
    }
    #wrapcontent aside.sidebar nav ul li a {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        padding: 3px 6px;
        color: inherit;
        text-decoration: none;
        font-weight: 500;
        font-size: 12px;
    }
    #wrapcontent aside.sidebar nav ul li a i {
        margin-right: 5px;
    }
    #wrapcontent aside.sidebar nav ul li h3 {
        text-transform: uppercase;
        padding: 6px;
        border-bottom: 1px solid #dfe2e7;
        font-size: 12px;
    }
    #wrapcontent aside.sidebar nav ul li a:focus {
        outline: 2px dashed #2b97be; /* Destaque para foco */
        outline-offset: 2px;
        background-color: #f2f2f2; /* Alterar o fundo ao receber foco */
    }
    #wrapcontent aside.sidebar nav ul li a:hover {
        background-color: #c8e6f0; /* Fundo mais claro */
        color: #125578; /* Destaque na cor do texto */
        transition: all 0.3s ease-in-out; /* Transição suave */
    }
    #wrapcontent .content {
        width: calc(100% - 230px);
    }
    #wrapcontent .content article {
        margin-top: 50px;
        padding: 15px;
    }
    #wrapcontent .content article .breadcrumb {
        font-weight: 600;
        color: #2b97be;
        font-size: 12px;
    }
    #wrapcontent .content article .breadcrumb .breadcrumb-item.active {
        color: #2b97be;
    }
    #wrapcontent .content article .breadcrumb .breadcrumb-item + .breadcrumb-item {
        padding-left: 4px;
    }
    #wrapcontent .content article .breadcrumb .breadcrumb-item + .breadcrumb-item:before {
        color: #2b97be;
        padding-right: 4px;
    }
    #wrapcontent .content article .row.psm {
        min-height: 100%;
        width: calc(100% + 15px);
        margin: 0 0 0 -15px;
    }
    #wrapcontent .content article .row.psm > * {
        display: flex;
        min-height: 100%;
        padding-left: 2px;
        padding-right: 2px;
    }
    #wrapcontent .content article .row.psm > * .block {
        width: 100%;
    }
    #wrapcontent .content article .row.psm > * .block .container-fluid {
        padding-left: 0;
        padding-right: 0;
    }
    #wrapcontent .content article .block {
        background: #f9f9fb;
        border-radius: 10px;
        padding: 15px 5px 20px;
        display: flex;
        flex-flow: wrap;
        min-height: 100%;
    }
    #wrapcontent .content article .block.h-auto {
        min-height: 0;
        height: auto;
    }
    #wrapcontent .content article .block h2 {
        margin-bottom: 10px;
    }
    #wrapcontent .content article .block h3 {
        font-weight: 600;
        color: #495058;
    }
    #wrapcontent .content article .block .label-graph {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 12px;
        padding: 6px 10px;
        border: 1px solid #495058;
        height: 44px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1.2;
        text-align: center;
        color: #495058;
        margin-bottom: 10px;
    }
    #wrapcontent .content article .block .donut {
        width: 100%;
        padding-top: 100%;
        position: relative;
    }
    #wrapcontent .content article .block .donut canvas {
        position: absolute;
        top: 0;
    }
    #wrapcontent .content article .block .donut span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 14px;
        line-height: 1;
        font-weight: 700;
        color: #495058;
    }
    #wrapcontent .content article .block .leg {
        min-height: 38px;
    }
    #wrapcontent .content article .block .graph-aging h4 {
        background: #2b97be;
        color: #ffffff;
        width: 100%;
        text-align: center;
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0;
        line-height: 1;
        font-weight: 600;
        width: calc(100% + 10px);
        margin: -15px -5px 0;
    }
    #wrapcontent .content article .block .graph-aging h3 {
        font-size: 18px;
        width: 100%;
        display: block;
        text-align: center;
        color: #2b97be;
        margin: 10px 0;
    }
    #wrapcontent .content article .block .cont-leg {
        border-top: 1px solid #495058;
        width: calc(100% + 10px);
        margin: 10px -5px 0;
        padding: 5px 15px;
        text-align: center;
    }
    #wrapcontent .content article .block.graph-balanco h3 {
        background: #2b97be;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        margin: 0;
        width: calc(100% + 10px);
        margin: -15px -5px 0;
    }
    #wrapcontent .content article .block.graph-balanco h4 {
        color: #2b97be;
        text-align: center;
    }
    #wrapcontent .content article .block.graph-balanco .cont-leg {
        display: block;
        border: 0;
    }
    #wrapcontent .content article .block .btn {
        text-transform: uppercase;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.2;
        transition: all 0.4s ease;
        padding: 8px 15px;
    }
    #wrapcontent .content article .block .btn.btn-sm {
        font-size: 12px;
        padding: 6px 10px;
    }
    #wrapcontent .content article .block .btn.btn-xs {
        font-size: 9px;
        padding: 4px 5px;
        border-radius: 3px;
        white-space: nowrap;
    }
    #wrapcontent .content article .block .btn.btn-xs i {
        font-size: 9px;
        margin-right: 2px;
        margin-left: 0;
    }
    #wrapcontent .content article .block .btn.btn-primary {
        background: #2b97be;
        border-color: #2b97be;
        color: #ffffff;
    }
    #wrapcontent .content article .block .btn.btn-primary i {
        color: inherit;
    }
    #wrapcontent .content article .block .btn.btn-primary:hover {
        background: #125578;
        border-color: #125578;
    }
    #wrapcontent .content article .block .btn.btn-secondary {
        background: #125578;
        border-color: #125578;
        color: #ffffff;
    }
    #wrapcontent .content article .block .btn.btn-secondary i {
        color: inherit;
    }
    #wrapcontent .content article .block .btn.btn-secondary:hover {
        background: #2b97be;
        border-color: #2b97be;
    }
    #wrapcontent .content article .block .btn.btn-gray {
        background: #495058;
        border-color: #495058;
        color: #ffffff;
    }
    #wrapcontent .content article .block .btn.btn-gray i {
        color: inherit;
    }
    #wrapcontent .content article .block .btn.btn-gray:hover {
        background: #262626;
        border-color: #262626;
    }
    #wrapcontent .content article .block .btn i {
        margin-right: 4px;
        margin-left: -2px;
    }
    #wrapcontent .content article .block .btn.btn-menu {
        padding: 0 3px;
        color: #125578;
    }
    #wrapcontent .content article .block .btn.btn-menu i {
        margin: 0;
    }
    #wrapcontent .content article .block .btn.btn-outline {
        border: 1px solid #dfe2e7;
    }
    #wrapcontent .content article .block .btn.btn-col {
        display: flex;
        flex-flow: column;
        align-items: center;
        justify-content: center;
        color: #2b97be;
        text-transform: none;
        border: 0;
    }
    #wrapcontent .content article .block .btn.btn-col i {
        font-size: 120%;
        color: #495058;
        margin: 0 0 4px 0;
    }
    #wrapcontent .content article .block .btn.btn-font-danger {
        color: #af2a37;
    }
    #wrapcontent .content article .block .btn.btn-font1 {
        color: #2b97be;
        text-transform: none;
    }
    #wrapcontent .content article .block .btn.btn-font1 i {
        color: inherit ;
    }
    #wrapcontent .content article .block .status-graph {
        color: #2b97be;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top: 1px solid #dfe2e7;
        width: 100%;
        padding: 3px 0 0;
        font-size: 12px;
        margin-top: 10px;
    }
    #wrapcontent .content article .block .status-graph i {
        margin-right: 4px;
    }
    #wrapcontent .content article .block figure.perfil {
        margin: 0;
    }
    #wrapcontent .content article .block figure.perfil img {
        height: 76px;
        width: 76px;
        border-radius: 100px;
        object-fit: cover;
        margin: 0;
    }
    #wrapcontent .content article .block ul.list {
        list-style: none;
        margin: 15px 0 0 0;
        color: #2b97be;
        padding: 0;
    }
    #wrapcontent .content article .block ul.list strong {
        color: #495058;
        font-weight: 600;
    }
    #wrapcontent .content article .block ul.list li {
        margin: 0 0 10px;
    }
    #wrapcontent .content article .block .steps {
        list-style: none;
        display: flex;
        width: 100%;
        flex-flow: row;
        align-items: flex-start;
        margin: 0;
    }
    #wrapcontent .content article .block .steps li {
        width: 100%;
        display: flex;
        flex-flow: column;
        align-items: center;
        padding: 0 8px;
        position: relative;
        justify-content: center;
    }
    #wrapcontent .content article .block .steps li:before {
        content: '';
        top: 30px;
        width: calc(100% - 60px);
        height: 1px;
        background: #495058;
        position: absolute;
        left: calc(50% + 30px);
    }
    #wrapcontent .content article .block .steps li:last-child:before {
        display: none;
    }
    #wrapcontent .content article .block .steps li span {
        width: 60px;
        height: 60px;
        border: 1px solid #495058;
        border-radius: 60px;
        color: #495058;
        font-weight: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
        text-align: center;
    }
    #wrapcontent .content article .block .steps li span i {
        color: #2b97be;
        font-size: 160%;
    }
    #wrapcontent .content article .block .steps li h3 {
        text-align: center;
        font-size: 11px;
        line-height: 1.2;
        margin: 10px 0 0 0;
        font-weight: normal;
    }
    #wrapcontent .content article .block .steps li.active span {
        background: #2b97be;
        color: #ffffff;
    }

    #wrapcontent .content article .block .steps li.pending span {
        background: #ececec;
    }

    #wrapcontent .content article .block .steps.vert {
        flex-flow: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin: 15px 0 0 15px;
        padding: 0;
    }
    #wrapcontent .content article .block .steps.vert li {
        align-items: center;
        justify-content: flex-start;
        flex-flow: wrap;
        margin-bottom: 20px;
        padding: 0;
    }
    #wrapcontent .content article .block .steps.vert li span {
        width: 40px;
        height: 40px;
    }
    #wrapcontent .content article .block .steps.vert li h3 {
        margin: 0 0 0 10px;
    }
    #wrapcontent .content article .block .steps.vert li:before {
        content: '';
        top: 40px;
        width: 1px;
        height: 20px;
        background: #495058;
        position: absolute;
        left: 20px;
    }
    #wrapcontent .content article .block .form {
        margin: 0;
    }
    #wrapcontent .content article .block .form .row {
        margin: 0 0 6px 0;
    }
    #wrapcontent .content article .block .form .row:last-child {
        margin: 0;
    }
    #wrapcontent .content article .block .form .row.pr15 {
        padding-right: 15px;
    }
    #wrapcontent .content article .block .form .row.mgn {
        margin: 0 -10px;
    }
    #wrapcontent .content article .block .form .row.mgn > *,
    #wrapcontent .content article .block .form .row.mgn > .col-12 {
        padding-left: 10px;
        padding-right: 10px;
    }
    #wrapcontent .content article .block .form .row .wrap-btn {
        display: flex;
        align-items: center;
        flex-flow: wrap;
        justify-content: flex-end;
        border: 1px solid #dfe2e7;
        border-radius: 5px;
        padding: 5px 10px !important;
        min-height: 76px;
    }
    #wrapcontent .content article .block .form .row label {
        font-weight: 600;
        font-size: 12px;
    }
    // tamanho do width do label do input
    #wrapcontent .content article .block .form .row label.col-auto {
        width: 170px;
        border: 1px solid #dfe2e7;
        border-radius: 5px 0 0 5px;
        text-transform: none;
        display: flex;
        align-items: center;
    }
    #wrapcontent .content article .block .form .row label.label-dinamico {
        border: 1px solid #dfe2e7;
        border-radius: 5px 0 0 5px;
        text-transform: none;
        display: flex;
        align-items: center;
        padding: 0 10px; 
    }
    #wrapcontent .content article .block .form .row label.col-auto small {
        display: inline-block;
    }
    #wrapcontent .content article .block .form .row .cor1 {
        color: #2b97be;
    }
    #wrapcontent .content article .block .form .row .fw600 {
        font-weight: 600;
    }
    #wrapcontent .content article .block .form .row .s12 {
        font-size: 12px;
    }
    #wrapcontent .content article .block .form .row div.col-auto {
        width: calc(100% - 180px);
        padding-left: 0;
        padding-right: 0;
        position: relative;
    }
    #wrapcontent .content article .block .form .row div.col-auto select {
        color: #2b97be;
    }
    #wrapcontent .content article .block .form .row div.col-auto.pr30 {
        padding-right: 30px;
    }
    #wrapcontent .content article .block .form .row div.col-auto button.search {
        width: 25px;
        height: 25px;
        transform: translate(0, -50%);
        color: #2b97be;
        position: absolute;
        right: -3px;
        top: 50%;
        border: 0;
        padding: 0;
        background: transparent;
    }
    #wrapcontent .content article .block .form .row.data label.col-auto {
        width: 80px;
        padding-left: 6px;
        padding-right: 5px;
    }
    #wrapcontent .content article .block .form .row.data div.col-auto {
        width: calc(100% - 80px);
        position: relative;
    }
    #wrapcontent .content article .block .form .row.data div.col-auto i {
        transform: translate(100%, -50%);
        color: #2b97be;
        position: absolute;
        right: -3px;
        top: 50%;
        font-size: 12px;
    }
    #wrapcontent .content article .block .form .row.row-form-sm label.col-auto {
        width: 110px;
    }
    #wrapcontent .content article .block .form .row.row-form-sm div.col-auto {
        width: calc(100% - 110px);
    }
    #wrapcontent .content article .block .form .row .col-12 {
        padding-left: 0;
        padding-right: 0;
    }
    #wrapcontent .content article .block .form .row select,
    #wrapcontent .content article .block .form .row .form-control {
        border-radius: 0 5px 5px 0;
        font-size: 14px;
    }
    #wrapcontent .content article .block .form .row fieldset legend {
        font-size: 12px;
        font-weight: 600;
        color: #2b97be;
    }
    #wrapcontent .content article .block .form .row fieldset > select {
        border-radius: 5px;
        font-size: 12px;
        margin-bottom: 5px;
        padding-left: 8px;
        color: #2b97be;
    }
    #wrapcontent .content article .block .form .row fieldset > .form-check.sm {
        height: 32px;
        margin-bottom: 5px;
        padding-top: 8px ;
    }
    #wrapcontent .content article .block .form .row fieldset.periodo legend {
        width: auto;
        white-space: nowrap;
        padding: 0 5px 0 0;
        font-size: 10px;
    }
    #wrapcontent .content article .block .form-check-input:checked {
        background-color: #2b97be;
        border-color: #2b97be;
    }
    #wrapcontent .content article .block .form-check.sm {
        font-size: 12px;
    }
    #wrapcontent .content article .block .alert {
        margin-bottom: 5px;
        padding: 5px 8px;
    }
    #wrapcontent .content article .block .alert i {
        margin-right: 4px;
    }
    #wrapcontent .content article .block .scroll-hor {
        overflow-x: auto;
        padding-bottom: 10px;
    }
    #wrapcontent .content article .block .scroll-hor .table {
        min-width: 880px;
    }
    #wrapcontent .content article .block .scroll-vert {
        overflow-y: auto;
        padding-right: 10px;
        max-height: 104px;
    }
    #wrapcontent .content article .block .scroll-vert.h2 {
        max-height: 203px;
    }
    #wrapcontent .content article .block .scroll-vert.h2 .table {
        font-size: 12px;
    }
    #wrapcontent .content article .block .scroll-vert.h3 {
        max-height: 396px;
    }
    #wrapcontent .content article .block .scroll-vert.h3 .table {
        font-size: 12px;
    }
    #wrapcontent .content article .block .table {
        font-size: 14px;
    }
    #wrapcontent .content article .block .table thead tr > * {
        vertical-align: middle;
    }
    #wrapcontent .content article .block .table.table-sm {
        font-size: 12px;
    }
    #wrapcontent .content article .block .table.table-striped tr:nth-child(odd):not(.table-danger) > * {
        background: transparent;
        --bs-table-accent-bg: transparent;
    }
    #wrapcontent .content article .block .table.table-striped tr:nth-child(even):not(.table-danger) > * {
        background: #ececec;
        --bs-table-accent-bg: #ececec;
    }
    #wrapcontent .content article .block .table.table-striped tr:nth-child(odd) > .bg1,
    #wrapcontent .content article .block .table.table-striped tr:nth-child(even) > .bg1 {
        background: #2b97be;
        color: #ffffff;
        font-weight: 500;
        --bs-table-accent-bg: #2b97be;
    }
    #wrapcontent .content article .block .table.table-striped tr:nth-child(odd) > .bg2,
    #wrapcontent .content article .block .table.table-striped tr:nth-child(even) > .bg2 {
        background: #125578;
        color: #ffffff;
        font-weight: 500;
        --bs-table-accent-bg: #125578;
    }
    #wrapcontent .content article .block .table i {
        color: #126c43;
        font-size: 16px;
    }
    #wrapcontent .content article .block .table .status i {
        color: inherit;
        font-size: inherit;
    }
    #wrapcontent .content article .block .table .bg1 {
        background: #2b97be;
        color: #ffffff;
        font-weight: 500;
        --bs-table-accent-bg: #2b97be;
    }
    #wrapcontent .content article .block .table .bg2 {
        background: #125578;
        color: #ffffff;
        font-weight: 500;
        --bs-table-accent-bg: #125578;
    }
    #wrapcontent .content article .block .table .table-danger i {
        color: #af2a37;
    }
    #wrapcontent .content article .block .table a {
        display: block;
    }
    #wrapcontent .content article .block .table a i {
        color: #495058;
    }
    #wrapcontent .content article .block .table .bignum {
        vertical-align: middle;
        text-align: center;
        font-size: 20px;
        font-weight: 700;
    }
    #wrapcontent .content article .block .table .icon {
        width: 31px;
    }
    #wrapcontent .content article .block .table .icon i {
        color: #495058;
    }
    #wrapcontent .content article .block .table .actn {
        width: 62px;
    }
    #wrapcontent .content article .block .table .actn a {
        width: 22px;
        align-items: center;
        justify-content: center;
        float: left ;
        display: flex;
    }
    #wrapcontent .content article .block .table .cor1 {
        color: #2b97be;
    }
    #wrapcontent .content article .block .table .cor1 i {
        color: #2b97be;
    }
    #wrapcontent .content article .block .table .red {
        color: #af2a37;
    }
    #wrapcontent .content article .block .table .red i {
        color: #af2a37;
    }
    #wrapcontent .content article .block .table .bg-lt {
        background: #f2f3f7 !important;
        --bs-table-accent-bg: #f2f3f7 !important;
    }
    #wrapcontent .content article .block .table .bg-lt2 {
        background: #ececec !important;
        --bs-table-accent-bg: #ececec !important;
    }
    #wrapcontent .content article .block .table tr.cor1 > * {
        color: #2b97be;
    }
    #wrapcontent .content article .block .table tr.cor1 > *.icon i {
        color: #2b97be;
    }
    #wrapcontent .content article .block .table td.click {
        width: 31px;
        padding: 0;
    }
    #wrapcontent .content article .block .table td.click a {
        width: 100%;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    #wrapcontent .content article .block .table td.inside {
        padding: 0;
    }
    #wrapcontent .content article .block .table td.inside table {
        background: #ffffff !important;
        margin: 0;
        font-size: 12px;
    }
    #wrapcontent .content article .block .table td.inside table table.table-striped {
        font-size: 10px;
    }
    #wrapcontent .content article .block .table td.inside table table.table-striped thead tr > * {
        border-color: #dee2e6;
        background: #d7d7d7;
        color: #495058;
    }
    #wrapcontent .content article .block .table td.inside table td.click a {
        height: 33px;
    }
    #wrapcontent .content article .block .table td.inside table .icon {
        width: 20px;
        padding: 0;
        text-align: center;
        vertical-align: middle;
    }
    #wrapcontent .content article .block .table td.inside table .icon i {
        font-size: 12px;
    }
    #wrapcontent .content article .block .table td.inside table tr th:first-child,
    #wrapcontent .content article .block .table td.inside table tr td:first-child {
        border-left-width: 0;
    }
    #wrapcontent .content article .block .table td.inside table tr th:last-child,
    #wrapcontent .content article .block .table td.inside table tr td:last-child {
        border-right-width: 0;
    }
    #wrapcontent .content article .block .col-linhas {
        font-size: 12px;
    }
    #wrapcontent .content article .block .col-linhas label {
        white-space: nowrap;
    }
    #wrapcontent .content article .block .col-linhas select {
        width: auto;
        font-size: 12px;
        margin-left: 10px;
        margin-right: 10px;
    }
    #wrapcontent .content article .block .pagination {
        margin: 0;
    }
    #wrapcontent .content article .block .pagination .page-item .page-link {
        color: #495058;
        font-weight: 500;
        text-transform: uppercase;
        font-size: 12px;
    }
    #wrapcontent .content article .block .pagination .page-item.active .page-link {
        background: #2b97be;
        border-color: #2b97be;
        color: #ffffff;
    }

    #wrapcontent .content article .block .graph2 {
        width: 100%;
        display: flex;
        align-items: center;
        flex-flow: column;
    }
    #wrapcontent .content article .block .graph2 .top {
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-flow: row;
        padding: 0 10px;
        width: 100%;
        margin: -15px 0 0 0;
    }
    #wrapcontent .content article .block .graph2 .top h4 {
        color: #125578;
        font-weight: 500;
    }
    #wrapcontent .content article .block .graph2 .top span {
        margin-right: -15px;
        background: #f2f3f7;
        padding: 10px;
        font-weight: 500;
        font-size: 14px;
        border-radius: 0 10px 0 0;
    }
    #wrapcontent .content article .block .graph2 .donut {
        width: 170px;
        padding-top: 170px;
    }

    #wrapcontent .content article .block .graph2-home .donut {
        width: 145px;
        padding-top: 145px;
    }

    #wrapcontent .content article .block ul.bar-legenda {
        list-style: none;
        margin: 0;
        padding: 0;
        display: flex;
        flex-flow: row;
        align-items: center;
        justify-content: flex-start;
    }
    #wrapcontent .content article .block ul.bar-legenda li {
        width: auto;
        margin: 0 0 0 15px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        font-size: 12px;
    }
    #wrapcontent .content article .block ul.bar-legenda li span {
        width: 12px;
        height: 12px;
        margin: 0 4px 0 0;
        background: #d7d7d7;
    }
    #wrapcontent .content article .block ul.bar-legenda li:nth-child(1) span {
        background: #2b97be;
    }
    #wrapcontent .content article .block .bar-wrap {
        width: 100%;
        display: flex;
        flex-flow: wrap;
        margin-bottom: 10px;
    }
    #wrapcontent .content article .block .bar-wrap:last-child {
        margin-bottom: 0;
    }
    #wrapcontent .content article .block .bar-wrap h4 {
        color: #2b97be;
        width: 50%;
        padding: 0 10px 0 0;
        display: flex;
        align-items: center;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal {
        width: 50%;
        display: flex;
        flex-flow: row;
        justify-content: space-between;
        height: 25px;
        background: #d7d7d7;
        font-size: 12px;
        font-weight: 700;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal .val {
        height: 100%;
        background: #2b97be;
        line-height: 20px;
        color: #ffffff;
        padding: 0 10px;
        text-align: right;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        min-width: 16%;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal span {
        height: 100%;
        margin-right: 10px;
        color: #2b97be;
        display: flex;
        align-items: center;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal.red .val {
        background: #af2a37;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal.vals {
        background: transparent;
        justify-content: space-between;
        margin: 2px 0 0 50%;
        height: auto;
    }
    #wrapcontent .content article .block .bar-wrap .bar-horizontal.vals small {
        font-weight: normal;
        font-size: 10px;
    }

    .border-radius0{
        border-radius: 0;
    }

    #modelcontent .row label.col-auto {
        width: 220px;
        border: 1px solid #dfe2e7;
        border-radius: 5px 0 0 5px;
        text-transform: none;
        display: flex;
        align-items: center;
    }

    #modelcontent .row form.col-auto {
        border-radius: 0 5px 5px 0;
        font-size: 14px;
    }

    #modelcontent .row {
        margin: 0 0 6px 0;
    }

    .btn-standard-height {
        height: 2rem; 
        line-height: 2rem;
    }
    
    .checkbox-square {
        width: 20px;
        height: 20px; 
        border: 1px solid #000; 
        margin-right: 8px; 
        position: relative;
    }

    
    .accordion-title {
        margin-top: 2px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        cursor: pointer;
        background-color: rgb(18, 85, 120);
        color: white;
    }

    /* Altera a cor da seta para branco */
    .accordion-button::after {
        color: #ffffff !important;
        filter: brightness(0) invert(1);
    }
    
    /* Cor do cabeçalho quando o Accordion está fechado */
    .accordion-button.collapsed {
        background-color: #125578 !important; /* Cor de fundo */
        color: #F9F9FB !important; /* Cor do texto */
    }

    /* Cor do cabeçalho quando o Accordion está aberto */
    .accordion-button {
        background-color: #0D3A4D !important; /* Cor de fundo */
        color: #FFFFFF !important; /* Cor do texto */
    }

    /* Header fixo com cor de fundo e bordas arredondadas */
    .custom-accordion-header {
        background-color: #2b97be; /* Cor de fundo desejada */
        color: #ffffff; /* Cor do texto */
        border-radius: 8px 8px 0 0; /* Arredonda somente as bordas superiores */
    }

    .datatable-title {
        font-weight: bold; 
        font-size: 18px; 
        color: #2b97be;
        margin-bottom: 8px; 
    }

    html  {
        overflow-y: scroll;
        scroll-behavior: smooth;
    }

    body.swal2-shown {
        overflow-y: scroll;
        overflow: visible !important;
        padding-right: 0 !important;
    }

    .filter-icon {
        color: #2b97be;
    }

    /* Altera a fonte e cor do placeholder do DatePicker do antd */
    .ant-picker-input > input::placeholder {
        font-family: 'Montserrat', sans-serif;
        color: #53575B !important;
    }

    /* Foco azul igual ao input customizado */
    .ant-picker.ant-picker-focused {
        box-shadow: 0 0 0 0.2rem rgba(43, 151, 190, 0.15);
        border-color: #2b97be;
    }

    /* Hover igual ao input customizado e ao react-select */
    .ant-picker:hover,
    .ant-picker:active {
        border-color: #2b97be;
    }

    /* Aplica o Montserrat e ajusta o tamanho da fonte nos títulos das abas */
    .ant-tabs-tab {
        font-family: 'Montserrat', sans-serif !important;
        font-size: 14px !important; /* ou o tamanho que preferir */
    }

    /* Estilo para a aba ativa (texto e peso da fonte) */
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
        color: #125578 !important;
        font-weight: 600;
    }

    /* Estilo para a linha (ink bar) abaixo da aba ativa */
    .ant-tabs-ink-bar {
        background-color: #125578 !important;
    }
    /* Cor do texto ao passar o mouse sobre a aba (hover) */
    .ant-tabs-tab:hover .ant-tabs-tab-btn {
        color: #125578;
    }

    /* Mais específico, afeta só os títulos dentro do modal do Ant Design */
    .ant-modal p,
    .ant-modal h1,
    .ant-modal h2,
    .ant-modal h3,
    .ant-modal h4 {
        font-family: 'Montserrat', sans-serif;  
    }

    .ant-modal h1 {
        font-size: 16px;
        color: #2b97be;
    }

    .ant-modal h2 {
        font-size: 14px;
        color: #125578;
    }

    .ant-modal h2 strong {
        color: #2b97be;
    }

    .ant-modal h3,
    .ant-modal h4 {
        font-size: 14px;
        color: #2b97be;
    }

    .ant-modal p {
        color:#495058;
    }

    .ant-modal-title {
        color: #495058 !important;
        font-weight: bold !important;
        font-size: 18px !important; 
    }

    .ant-modal-content {
        font-family: 'Montserrat', sans-serif;
    }

    /* Aplica cor personalizada SOMENTE se o checkbox estiver marcado E habilitado */
    .ant-checkbox-checked:not(.ant-checkbox-disabled) .ant-checkbox-inner {
        background-color: #2b97be;
        border-color: #2b97be;
    }

    /* Mantém cor cinza quando o checkbox está desabilitado */
    .ant-checkbox-disabled .ant-checkbox-inner {
        background-color: #f5f5f5;  /* fundo cinza claro */
        border-color: #d9d9d9;      /* borda cinza */
    }

    /* Também mantém o símbolo de "check" visível mesmo desabilitado */
    .ant-checkbox-disabled .ant-checkbox-inner::after {
        border-color: #999999; /* cinza do check */
    }
    /* Aplica cor personalizada ao radio SE estiver selecionado E habilitado */
    .ant-radio-checked:not(.ant-radio-disabled) .ant-radio-inner {
        border-color: #2b97be;
        background-color: #2b97be;
    }

    /* Mantém estilo cinza se estiver desabilitado */
    .ant-radio-disabled .ant-radio-inner {
        background-color: #f5f5f5;  /* cinza claro */
        border-color: #d9d9d9;      /* cinza padrão */
    }

    /* Cor do círculo interno (indicador de seleção) mesmo se desabilitado */
    .ant-radio-disabled .ant-radio-inner::after {
        background-color: #999999;
    }

    /* Altera o fundo do campo de data desabilitado */
    .ant-picker-disabled {
        background-color: #e9ecef !important;
        cursor: not-allowed !important;
    }

    /* Altera a cor do texto (data) dentro do campo */
    .ant-picker-disabled .ant-picker-input > input {
        color: #000 !important;
    }

    .input-audit-focus:focus {
        box-shadow: 0 0 0 0.2rem rgba(43, 151, 190, 0.15);
        border-color: #2b97be;
    }

    /* Estilo do Toast de Boas-Vindas */
    .subtitle-toast.swal2-popup.swal2-toast .swal2-title {
        margin: 0 0 4px;
        font-size: 16px;
        font-weight: 700;
    }

    .subtitle-toast.swal2-popup.swal2-toast .swal2-html-container {
        margin: 0;
        font-size: 13px;
        line-height: 1.4;
        font-weight: 400;
        opacity: 1;
        color: #444;
    }

    .subtitle-toast.swal2-popup.swal2-toast .toast-subtitle {
        display: block;
        margin-top: 4px;
    }

  

`